<template>
  <main class="py-10 flex flex-col gap-4 justify-center items-center">
    <h3 class="text-h-primary-500 w-full px-4 xl:max-w-[1200px]">
      {{ "Atividades" }}
    </h3>
    <Loader :loader="loading.activities" />
    <div
      class="min-h-[500px] flex flex-col gap-4 max-w-[320px] w-full sm:max-w-[500px] md:max-w-[800px] lg:max-w-[900px] xl:max-w-[1200px]"
      v-if="activities.length > 0 && !loading.activities"
    >
      <div v-for="(activity, index) in activities" :key="index">
        <div
          class="border-2 p-4 rounded-md flex flex-col lg:flex-row justify-center md:justify-between items-center gap-4"
        >
          <h6>{{ activity.title }}</h6>
          <div class="flex flex-col lg:flex-row gap-6">
            <div class="flex flex-col md:flex-row gap-6">
              <span
                class="flex flex-row items-center gap-2 w-[270px] md:justify-end"
                v-html="activity.info"
              >
              </span>
              <span class="flex flex-row items-center gap-2 w-[280px]">
                <h6>
                  {{ "Status:" }}
                </h6>
                <p
                  :class="activity.status?.class"
                  :v-tooltip="activity.status?.tooltip"
                >
                  <v-icon :name="activity.status?.icon" />
                  {{ activity.status?.text }}
                </p>
              </span>
            </div>

            <Button
              class="btn-outline"
              :label="
                $t('labels.generic', {
                  pt: 'Ver Atividade',
                  en: 'See Activity',
                })
              "
              @click.prevent="goToActivity(activity?.activityId!)"
              iconPos="right"
              icon="pi pi-chevron-right"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="mt-10 md:mt-20" v-else>
      <EmptyData
        v-if="activities.length === 0 && !loading.activities"
        :data="activities.length === 0"
        :title="emptyState.title"
        :label="emptyState.description"
        :image="emptyState.image"
        imgSize="h-40 my-10 "
        msgSize="w-full"
      />
    </div>
    <Paginator
      v-if="params?.total! >params?.size "
      :rows="params?.size"
      :totalRecords="params?.total"
      @page="paginateActivities"
    ></Paginator>
  </main>
</template>
<script lang="ts">
import { QueryParams } from "@/models/query-params.model";
import { ActivityRest } from "@/services/rest/activity.rest";
import { GoToRoute } from "@/utils/go-to.util";
import { defineComponent } from "vue";
import { activities } from "./activity.mock";
import { toDomain } from "./activity.mapper";
import { StudentActivityTableInfo } from "@/models/activity.model";
import { PageState } from "primevue/paginator";
import EmptyData from "@/components/EmptyData/empty-data.vue";
export default defineComponent({
  data() {
    return {
      courseId: this.$route?.params?.courseId as string,
      activities: [] as StudentActivityTableInfo[],
      params: {
        size: 5,
        page: 0,
        total: 0,
      } as QueryParams,
      loading: { activities: false },
      emptyState: {
        title: "Nenhuma atividade encontrada",
        description: "Você ainda não possui atividades cadastradas",
        image: "empty-activity.svg",
      },
    };
  },
  computed: {
    rest(): ActivityRest {
      return new ActivityRest();
    },
    go(): GoToRoute {
      return new GoToRoute();
    },
    classroomId(): string {
      return localStorage.getItem("classId") ?? "";
    },
  },
  methods: {
    getAllActivities() {
      this.loading.activities = true;
      this.rest
        .getStudentActivitiesByClass(this.classroomId, this.params)
        .subscribe({
          next: (response) => {
            this.activities = toDomain(response.content);
            this.loading.activities = false;
            this.params = {
              size: response.size,
              page: response.page,
              total: response.total,
            };
          },
          error: () => {
            this.loading.activities = false;
          },
          complete: () => {
            this.loading.activities = false;
          },
        });
    },

    goToActivity(activityId: string) {
      this.$router.push({
        name: "activityStudentDetail",
        params: { ...this.$route.params, activityId },
      });
    },
    paginateActivities(event: PageState) {
      this.params.page = event.page;
      this.params.size = event.rows;
      this.getAllActivities();
    },
  },
  mounted() {
    this.getAllActivities();
  },
});
</script>
